import { render, staticRenderFns } from "./pwa-install-fab.vue?vue&type=template&id=f0af9d72&scoped=true"
import script from "./pwa-install-fab.vue?vue&type=script&lang=js"
export * from "./pwa-install-fab.vue?vue&type=script&lang=js"
import style0 from "./pwa-install-fab.vue?vue&type=style&index=0&id=f0af9d72&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0af9d72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0af9d72')) {
      api.createRecord('f0af9d72', component.options)
    } else {
      api.reload('f0af9d72', component.options)
    }
    module.hot.accept("./pwa-install-fab.vue?vue&type=template&id=f0af9d72&scoped=true", function () {
      api.rerender('f0af9d72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pwa-install-fab.vue"
export default component.exports